// ReportHeaderProjectStat Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ProgressBar from '../../../common/common/progress_bar/progress_bar.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

class ReportHeaderProjectStat extends Component {
  static get propTypes () {
    return {
      stat: PropTypes.object,
      isPlannerAllowed: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      stat: null,
      isPlannerAllowed: false
    }
  }

  render () {
    const reportStat = this.props.stat

    return (
      <div className='report-header-projectstat'>
        <div className='list'>
          <div className='item'>
            <h3 className='title'>
              <IntlMessage ident='report.header.trackedVsBudget' />
            </h3>
            <h3 className='subtitle'>
              {reportStat.totalTrackedVsBudgetedPerc
                ? reportStat.totalTrackedVsBudgetedPerc
                : 0}
              %
            </h3>
            <ProgressBar
              value={
                reportStat.totalTrackedVsBudgetedPerc
                  ? reportStat.totalTrackedVsBudgetedPerc
                  : 0
              }
              mode='determinate'
              max={100}
              buffer={100}
              type='linear'
            />
            <div className='info'>
              <span className='total'>
                {reportStat.totalTracked ? (
                  <PriceText value={reportStat.totalTracked} />
                ) : (
                  '0.00'
                )}
              </span>
              <span className='subtotal'>
                {reportStat.totalBudget ? (
                  <PriceText value={reportStat.totalBudget} />
                ) : (
                  '0.00'
                )}
              </span>
            </div>
          </div>
          {this.props.isPlannerAllowed && (
            <div className='item'>
              <h3 className='title'>
                <IntlMessage ident='report.header.trackedVsPlanned' />
              </h3>
              <h3 className='subtitle'>
                {reportStat.totalTrackedVsPlannedPerc
                  ? reportStat.totalTrackedVsPlannedPerc
                  : 0}
                %
              </h3>
              <ProgressBar
                value={
                  reportStat.totalTrackedVsPlannedPerc
                    ? reportStat.totalTrackedVsPlannedPerc
                    : 0
                }
                mode='determinate'
                max={100}
                buffer={100}
                type='linear'
              />
              <div className='info'>
                <span className='total'>
                  {reportStat.totalTracked ? (
                    <PriceText value={reportStat.totalTracked} />
                  ) : (
                    '0.00'
                  )}
                </span>
                <span className='subtotal'>
                  {reportStat.totalPlanned ? (
                    <PriceText value={reportStat.totalPlanned} />
                  ) : (
                    '0.00'
                  )}
                </span>
              </div>
            </div>
          )}
          <div className='item'>
            <h3 className='title'>
              <IntlMessage ident='report.header.budgetVsInvoiced' />
            </h3>
            <h3 className='subtitle'>
              {reportStat.totalBudgetVsInvoicedPerc
                ? reportStat.totalBudgetVsInvoicedPerc
                : 0}
              %
            </h3>
            <ProgressBar
              value={
                reportStat.totalBudgetVsInvoicedPerc
                  ? reportStat.totalBudgetVsInvoicedPerc
                  : 0
              }
              mode='determinate'
              max={100}
              buffer={100}
              type='linear'
            />
            <div className='info'>
              <span className='total'>
                {reportStat.totalBudget ? (
                  <PriceText value={reportStat.totalBudget} />
                ) : (
                  '0.00'
                )}
              </span>
              <span className='subtotal'>
                {reportStat.totalInvoiced ? (
                  <PriceText value={reportStat.totalInvoiced} />
                ) : (
                  '0.00'
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ReportHeaderProjectStat
